(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-size-pack-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-pack-picker')) {
    class SizePackPicker extends HTMLElement {
      connectedCallback() {
        this.onChange = this.onChange.bind(this);
        this.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }

      onChange(event) {
        const sizeInput = event.target;
        if (!(sizeInput instanceof HTMLInputElement) || !sizeInput.hasAttribute('data-size-target')) return;

        event.stopPropagation();

        const picker = this.closest('variant-picker');
        if (!picker) return;

        const key = sizeInput.dataset.sizeKey;
        picker.querySelectorAll('[data-pack-size-key]').forEach((item) => {
          item.hidden = item.dataset.packSizeKey !== key;
        });

        const target = document.getElementById(sizeInput.dataset.sizeTarget);
        if (!target || target.type !== 'radio') return;

        const sizeLabel = sizeInput.nextElementSibling;
        const selectedSize = picker.querySelector('[data-selected-size-label]');
        if (sizeLabel && selectedSize) selectedSize.innerHTML = sizeLabel.innerHTML;

        const selectedPack = picker.querySelector('[data-selected-pack-size]');
        if (selectedPack) selectedPack.textContent = target.dataset.packLabel || '';

        if (target.checked) return;

        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    customElements.define('size-pack-picker', SizePackPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["weight-unit-toggle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('weight-unit-toggle')) {
    class WeightUnitToggle extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
        this.setUnit(WeightUnitToggle.getStoredUnit(), false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      static getStoredUnit() {
        try {
          return window.localStorage.getItem('mypura-baby-weight-unit') === 'lbs' ? 'lbs' : 'kg';
        } catch (error) {
          return 'kg';
        }
      }

      static storeUnit(unit) {
        try {
          window.localStorage.setItem('mypura-baby-weight-unit', unit);
        } catch (error) {}
      }

      onClick(event) {
        if (event.target.closest('.weight-unit-toggle__lbs')) {
          this.setUnit('lbs', true);
          return;
        }

        if (event.target.closest('.weight-unit-toggle__kg')) {
          this.setUnit('kg', true);
          return;
        }

        if (event.target.closest('[role="switch"]')) {
          this.setUnit(this.dataset.unit === 'kg' ? 'lbs' : 'kg', true);
        }
      }

      setUnit(unit, persist) {
        const isKg = unit === 'kg';
        document.documentElement.setAttribute('data-baby-weight-unit', unit);
        document.querySelectorAll('weight-unit-toggle').forEach((el) => {
          el.dataset.unit = unit;
          const switchEl = el.querySelector('[role="switch"]');
          if (switchEl) switchEl.setAttribute('aria-checked', isKg ? 'true' : 'false');
        });
        if (persist) WeightUnitToggle.storeUnit(unit);
      }
    }

    customElements.define('weight-unit-toggle', WeightUnitToggle);
  }
  } catch(e) { console.error(e); }
})();

})();
